export default function deprecate() {
  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  console.warn("[FLAMELINK] The \"".concat(method, "\" method is deprecated and will be removed in the next major version. ").concat(message));
}